<template>
  <router-view />
  <Toast />

  <!-- loading logo show on the first load -->
  <div class="logo-loading" :class="{ 'fade-out': !loading }">
    <img src="@/assets/imgs/loading-logo.png" alt="" class="logo">
  </div>
</template>

<script setup>
import Toast from 'primevue/toast';
import { onMounted, ref } from 'vue';
import { useToast } from 'primevue/usetoast';

import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const toast = useToast();

const firebaseConfig = {
  apiKey: "AIzaSyDitnDNvrMHb8_H0BR6Q9b3J2VBoHJdVSw",
  authDomain: "homra-c6af8.firebaseapp.com",
  projectId: "homra-c6af8",
  storageBucket: "homra-c6af8.firebasestorage.app",
  messagingSenderId: "32720666961",
  appId: "1:32720666961:web:b925cb3b90f611a40e9370",
  measurementId: "G-1GNXER7QTQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const loading = ref(false);



// Get registration token. Initially this makes a network call, once retrieved
// subsequent calls to getToken will return from cache.
const messaging = getMessaging();

onMessage(messaging, (payload) => {
  console.log('Message received. ', payload);

  toast.add({
    severity: 'info', detail: `${payload.notification.title} 
  ${payload.notification.body}`, life: 3000
  });
  // ...
});


// 
onMounted(() => {
  getToken(messaging, { vapidKey: 'BGkZmOOL74p1sAHY1ezHNFCs4qOG76Cb2zDECB_LN084NmaaEVWNgs2a1hqucQzNgOBTU4Scphx7eE7qXrr0MlY' }).then((currentToken) => {
    if (currentToken) {
      // Send the token to your server and update the UI if necessary
      // console.log('currentToken', currentToken);
      localStorage.setItem('fcmToken', currentToken);
      // ...
    } else {
      // Show permission request UI
      console.log('No registration token available. Request permission to generate one.');
      // ...
    }
  }).catch((err) => {
    console.log('An error occurred while retrieving token. ', err);
    
    // ...
  });

  // ------------------------------------------------- //
  if (!sessionStorage.getItem('isLodded')) {
    sessionStorage.setItem('isLodded', true);
    setTimeout(() => {
      loading.value = false;
    }, 1500);
    loading.value = true;
  }else{
      loading.value = false;
    }
});
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.logo-loading {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 4444;
  top: 0;
  left: 0;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all .7s ease-in-out;
  opacity: 1;
}

.fade-out {
  opacity: 0;
  z-index: -1;
}
</style>
